<app-modal-base [title]="dialogTitle" (onSubmitEvent)="onSubmit()" [loading]="isLoading" cancelType="CLOSE"
  [isDisabled]="form.invalid || docsSelectDisabled">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
  <ng-container footer *ngTemplateOutlet="footerContent"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div class="formContainer d-flex justify-content-center">
      <form [formGroup]="form">
        <p class="text-center">Sélectionnez les documents</p>
        <!-- all -->
        <span class="all">
          <mat-checkbox (change)="onClickAllDocument($event)" [disabled]="docsSelectDisabled">
            {{'all' | translate}}</mat-checkbox>
        </span>
        <!-- list -->
        <span>
          <ul formArrayName="documents">
            <li *ngFor="let item of documents">
              <mat-checkbox (change)="onClickDocument($event, item)" [checked]="allChecked || forceDocChecked[item.uid]"
                [disabled]="docsSelectDisabled">{{item.name}}
              </mat-checkbox>
            </li>
          </ul>
        </span>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #footerContent>
  <div class="text-center">
    <div *ngIf="currentExport?.state === ActionState.IN_PROGRESS" class="mb-3">
      <p>Les documents sont en cours de préparation</p>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <div *ngIf="currentExport?.state === ActionState.SUCCESS">
      <p>Le téléchargement est prêt !</p>
      <a mat-flat-button class="m-2" color="primary" download [href]="exportDownloadUrl">Télécharger</a>
      <button mat-flat-button class="m-2" color="primary" (click)="cancelExport()">Nouvelle sélection</button>
    </div>
    <div *ngIf="currentExport?.state === ActionState.ERROR">
      <p class="alert-danger">Une erreur est survenue : {{currentExport?.error}}</p>
    </div>
  </div>
</ng-template>
